<mat-card>
  <ng-content></ng-content>
</mat-card>
